/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
// UI
import React from "react";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import async from "async";
import DropIcon from "../../../assets/images/overhaul/icons/DropIcon.png";
import { s3ESVPrivate, s3AutomationPrivate } from "../../../utils/aws";
import LoadingContainer from "./components/LoadingContainer";
import FailedReportsModal from "./components/sendReportsUploadComponents/FailedReportsModal";
import FailedReportsEmailModalUpload from "./components/sendReportsUploadComponents/FailedReportsEmailModalUpload";
import FailedReportsParseModal from "./components/sendReportsUploadComponents/FailedReportsParseModal";
// action
import {
  getCustomers,
  getData,
  saveData,
  sendS3UrlGrouped,
} from "../../../actions/sendReportsUpload";

import { moveFilesToHistory } from "../../../actions/sendReports";
import { uploadFileToS3 } from "../../../utils/helpers";

import "./SendReportsUpload.css";

class SendReportsUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showFailedReports: false,
      failedReports: [],
      failedReportsEmail: [],
      showFailedReportsEmail: false,
      showFailedReportsParse: false,
      groupedCompanyNamesAndDate: {},
      fileFailedToParse: [],
      emailSent: [],
    };
  }

  componentDidMount() {
    // this.getCustomerApi();
  }

  getCustomerApi = async () => {
    const response = await getCustomers();
    if (!response.success) {
      toast.error(response.message);
    }
  };

  // triggered when user click gray area to upload pdfs
  handleUploadPdf = async (e) => {
    const files = e.target.files;
    const reports = [];
    const reportsRenamed = [];
    const reportsRenamedWithWO = [];
    const fileTypeObj = {};
    const failedReportsParse = [];
    const s3UrlsAndIDs = [];
    this.setState({ loading: true });
    // let reportDate;
    if (files) {
      for (let idx = 0; idx < files.length; idx++) {
        try {
          // let dotIndex;
          const file = files[idx];
          // let extension = "";
          const nameWithoutSpace = file.name.split(" ").join("");
          const names = file.name.split("-");
          let nameCompany = "";
          let woCompany;
          let type = "";
          let reportID = "";
          // for (let i = nameWithoutSpace.length - 1; i >= 0; i--) {
          //   if (nameWithoutSpace[i] === ".") {
          //     dotIndex = i;
          //     break;
          //   }
          // }
          // extension = nameWithoutSpace
          //   .substring(dotIndex + 1, nameWithoutSpace.length)
          //   .toUpperCase();

          // if (extension === "PDF") {
          // name and wo from file name
          let woIndex = -1;
          for (let i = names.length - 1; i >= 0; i--) {
            const rIndex = names[i].indexOf("R");
            const dIndex = names[i].indexOf("D");
            const string = names[i];
            let subStringR = "";
            let subStringD = "";
            let numR = false;
            let numD = false;
            const pesticideRegExr = /^\d+P$/; // numer of report + "P", for example 5P
            if (rIndex !== -1 && dIndex !== -1) {
              subStringR = string.substring(rIndex + 1, string.length);
              subStringD = string.substring(dIndex + 1, rIndex);
              numR = /^\d+$/.test(subStringR);
              numD = /^\d+$/.test(subStringD);
              if (numD && pesticideRegExr.test(subStringR)) {
                // check for pesticide report, D0518R5P
                woIndex = i;
                break;
              } else if (numR && numD) {
                // check for normal report, D0518R384
                woIndex = i;
                break;
              }
            }
          }

          if (woIndex !== -1) {
            woCompany = names[woIndex];
            reportID = woCompany;
            if (names[names.length - 1].includes("ER")) type = "env";
            if (names[names.length - 1].includes("PR")) type = "product";
            if (
              names[names.length - 1].includes("ER")
              || names[names.length - 1].includes("PR")
            ) {
              // files generated by the new program
              const newFile = names.length - 1;
              for (let i = woIndex + 1; i < newFile; i++) {
                if (nameCompany.length < 1) {
                  nameCompany = names[i];
                } else {
                  nameCompany = `${nameCompany}-${names[i]}`;
                }
              }
            } else {
              // files generated by the old program
              const lastString = names.length - 1;
              const stringLength = names[lastString].length;
              const oldFile = names.length;
              names[lastString] = names[lastString].substring(
                0,
                stringLength - 4,
              );
              for (let i = woIndex + 1; i < oldFile; i++) {
                if (nameCompany.length < 1) {
                  nameCompany = names[i];
                } else {
                  nameCompany = `${nameCompany}-${names[i]}`;
                }
              }
            }
          }

          // date from file
          // let currentYear = moment(Date.now()).format("YYYY")
          const pdfDate = woCompany.split("D")[0].substring(0, 6);
          // function formatDate(str, n) {
          //   var dateArr = [];
          //   for(let i = 0; i < str.length; i += n) {
          //     dateArr.push(str.substr(i, n))
          //   }
          //   return dateArr
          //  };

          // let dateFormatted = formatDate(pdfDate, 2).join('/');
          // let date = moment(dateFormatted + "/" + currentYear).format("YYYY-MM-DD");
          // reportDate = date + " 0:0"

          // wo from file
          const fileArr = woCompany.split("D");
          const originalS3Url = `media/batch_reports/history/${file.name}`;
          if (!!fileArr && fileArr.length > 0) {
            file.wo = fileArr[0];
            const orderID = fileArr[0];
            const UrlId = {
              url: nameWithoutSpace,
              id: orderID,
              companyName: nameCompany,
              date: pdfDate,
              originalS3Url, // For the sendreports/, we attach the original path
            };
            s3UrlsAndIDs.push(UrlId);
          }

          const renamedFile = new File([file], nameWithoutSpace, {
            type: file.type,
            wo: fileArr[0],
          });
          // fileTypeObj[fileArr[0]] = type;
          fileTypeObj[reportID] = type;
          reports.push(file);
          reportsRenamed.push(renamedFile);
          // reportsRenamedWithWO.push({file: renamedFile, wo: fileArr[0], companyName: nameCompany, date: reportDate});
          reportsRenamedWithWO.push({
            file: renamedFile,
            wo: fileArr[0],
            companyName: nameCompany,
            reportID,
          });
          const { success } = await uploadFileToS3({
            file,
            key: originalS3Url,
            type: file.type,
          }, s3AutomationPrivate);
          if (!success) {
            toast.error("Failed to upload report to S3");
            this.setState({
              loading: false,
              showFailedReportsEmail: false,
              groupedCompanyNamesAndDate: [],
              emailSent: [],
            });
            return;
          }
          // } else {
          //   this.clearFileInput();
          //   toast.error("You can upload PDFs only.");
          //   return;
          // }
        } catch (error) {
          console.error("Upload error: ", error);
          toast.error("Upload error: ", error);
          failedReportsParse.push(files[idx].name);
          this.setState({ loading: false });
          return;
          // this.clearFileInput();
        }
      }
      if (failedReportsParse.length > 0) {
        this.setState({
          fileFailedToParse: failedReportsParse,
          showFailedReportsParse: true,
        });
      }
      this.groupByCompanyNamesAndDate(s3UrlsAndIDs);
      this.setState({
        loading: true,
      }, () => {
        const {
          groupedCompanyNamesAndDate, emailSent,
        } = this.state;
        if (!!reports && reports.length > 0) {
          this.apiGetSamplesForWO(reportsRenamedWithWO).then((res1) => { // samples
            if (res1 && Object.keys(res1.params).length > 0) {
              this.addReportsToAWS(reportsRenamedWithWO, (err2, res2) => { // s3
                if (res2 && res2.code === 200) {
                  this.apiPostSampleForWO( // esv
                    res1.params,
                    fileTypeObj,
                    res2.params,
                  ).then(() => {
                    this.apiPosts3UrlsGrouped(groupedCompanyNamesAndDate).then(() => { // email
                      console.log("FilesUploaded: ", reportsRenamedWithWO, "\nEmailGroup: ", groupedCompanyNamesAndDate);
                      this.moveFilesToHistory(emailSent);
                      this.clearFileInput();
                      this.setState({
                        loading: false,
                        showFailedReportsEmail: true,
                        groupedCompanyNamesAndDate: [],
                        emailSent: [],
                      });
                    });
                  });
                } else {
                  toast.error(
                    "Something went wrong (AWS S3)",
                  );
                  this.clearFileInput();
                  this.setState({
                    loading: false,
                    showFailedReportsEmail: false,
                    groupedCompanyNamesAndDate: [],
                    emailSent: [],
                  });
                }
              });
            } else if (res1.code === 500) {
              toast.error(
                "Something went wrong (Get Samples).",
              );
              this.clearFileInput();
              this.setState({
                loading: false,
                groupedCompanyNamesAndDate: [],
                emailSent: [],
              });
            } else if (Object.keys(res1.params).length === 0) {
              toast.error("Oops! No file data (Get Samples).");
            }
          });
        }
      });
    }
  };

  moveFilesToHistory = async (emailsSent) => {
    const payload = [];
    emailsSent.forEach((file) => {
      payload.push(file.order_id);
    });
    await moveFilesToHistory(payload);
  };

  // groupByCompanyNames = (s3UrlsAndIDs) => {
  //   let grouped = {};
  //   s3UrlsAndIDs.forEach(function (a) {
  //     grouped[a.companyName] = grouped[a.companyName] || [];
  //     grouped[a.companyName].push({ s3_url: a.url, order_id: a.id });
  //   });
  //   this.setState({
  //     groupedCompanyNames: (this.state.groupedCompanyNames = { ...grouped }),
  //   });
  // };

  // clear the file input to allow uploading the same files again
  clearFileInput = () => {
    const uploadedReport = document.getElementById("uploadedReport");
    if (uploadedReport) {
      uploadedReport.value = "";
    }
  };

  // api call to get sample data for uploaded reports using work order number
  apiGetSamplesForWO = async (reportsRenamedWithWO) => {
    const reportsData = {};
    const ctgs = {};
    let code = 200;
    for (const file of reportsRenamedWithWO) {
      const response = await getData(file);
      if (response && response.success) {
        reportsData[file.reportID] = response.samples;
        ctgs[file.reportID] = response.ctg;
      } else {
        code = 500;
      }
    }
    return {
      params: reportsData,
      ctgs,
      code,
    };
  };

  // save the uploaded reports to AWS
  addReportsToAWS = (reports, callback) => {
    const reportsPath = {};
    async.each(
      reports,
      (file, eachcallback) => {
        uploadFileToS3({
          file: file.file,
          key: `COAs/${file.file.name}`,
          type: file.file.type,
        }, s3ESVPrivate, true).then(({ success, path }) => {
          if (success && path) {
            reportsPath[file.reportID] = path;
            eachcallback();
          } else {
            callback(null, { code: 500 });
          }
        });
      },
      (err) => {
        callback(err, { params: reportsPath, code: 200 });
      },
    );
  };

  // post api call to save sample data with path to DB
  apiPostSampleForWO = async (reportsData, ctgs, reportsPath) => {
    const params = this.createPostParams(reportsData, ctgs, reportsPath);
    const failedReports = new Set();
    for (const param of params) {
      const response = await saveData(param);
      if (response && !response.success) {
        failedReports.add(param.data.path);
      }
    }
    return { failedReports };
  };

  // // get api call to send s3Urls
  // apiGet3Urls = async (s3UrlsAndIDs) => {
  //   // let response = await sendS3Url(s3UrlsAndIDs[0]);
  //   for (const data of s3UrlsAndIDs) {
  //     let response = await sendS3Url(data);
  //     if (!response.success) {
  //       console.log(`Failed: ${data.url} `);
  //     }
  //   }
  // };

  // post api call to send s3Urls
  apiPosts3UrlsGrouped = async (groupedCompanyNamesAndDate) => {
    const { failedReportsEmail, emailSent } = this.state;
    // eslint-disable-next-line guard-for-in
    for (const key in groupedCompanyNamesAndDate) {
      const response = await sendS3UrlGrouped(groupedCompanyNamesAndDate[key]);
      if (response.success) {
        // if (response["0"].failed_for.length > 0) {
        //   console.log(
        //     "Failed For (Server Response):",
        //     response["0"].failed_for
        //   );
        //   alert(`Failed for: \n${response["0"].failed_for.join("\n")}`);
        // }
        emailSent.push(...groupedCompanyNamesAndDate[key]);
      } else {
        failedReportsEmail.push(...groupedCompanyNamesAndDate[key]);
      }
    }

    this.setState({
      failedReportsEmail,
      emailSent,
    });
  };

  // create post params
  createPostParams = (reportsData, ctgs, reportsPath) => {
    const params = [];
    for (const [key, value] of Object.entries(reportsData)) {
      const path = reportsPath[`${key}`];
      const ctg = ctgs[`${key}`];
      for (let j = 0; j < value.length; j++) {
        const obj = value[j];
        obj.path = path;
        params.push({ ctg, data: obj });
      }
    }

    return params;
  };

  closeFailedReportsModal = (showFailedReports, failedReports) => {
    this.clearFileInput();
    this.setState({
      showFailedReports,
      failedReports,
    });
  };

  toggleFailedReportsEmailModal = () => {
    const { showFailedReportsEmail } = this.state;
    this.clearFileInput();
    this.setState({
      showFailedReportsEmail: !showFailedReportsEmail,
      failedReportsEmail: [],
    });
  };

  toggleFailedReportsParseModal = () => {
    const { showFailedReportsParse } = this.state;
    this.clearFileInput();
    this.setState({
      showFailedReportsParse: !showFailedReportsParse,
      fileFailedToParse: [],
      // reports: [],
      // reportsRenamed: [],
      // reportsRenamedWithWO: [],
      // s3UrlsAndIDs: [],
      // groupedCompanyNames: [],
      groupedCompanyNamesAndDate: [],
    });
  };

  groupByCompanyNamesAndDate(s3UrlsAndIDs) {
    const { groupedCompanyNamesAndDate } = this.state;
    const groups = {};
    s3UrlsAndIDs.forEach((item) => {
      const group = [item.companyName, item.date];
      groups[group] = groups[group] || [];
      groups[group].push({ s3_url: item.originalS3Url, order_id: item.id });
    });
    this.setState({ groupedCompanyNamesAndDate: { ...groups } }, () => console.log("EmailGroup:", groupedCompanyNamesAndDate));
  }

  render() {
    const {
      loading,
      showFailedReports,
      failedReports,
      failedReportsEmail,
      showFailedReportsEmail,
      fileFailedToParse,
      showFailedReportsParse,
    } = this.state;

    return (
      <div className="dropzone">
        {loading ? <LoadingContainer /> : null}
        {showFailedReports ? (
          <FailedReportsModal
            onToggleModal={this.closeFailedReportsModal}
            reports={failedReports}
          />
        ) : null}
        {showFailedReportsEmail && (
          <FailedReportsEmailModalUpload
            failedReportsEmail={failedReportsEmail}
            toggleFailedReportsEmailModal={this.toggleFailedReportsEmailModal}
          />
        )}
        {showFailedReportsParse && (
          <FailedReportsParseModal
            fileFailedToParse={fileFailedToParse}
            toggleFailedReportsParseModal={this.toggleFailedReportsParseModal}
          />
        )}

        <div>
          <div className="dropZoneUploadHeader"> Upload </div>
          <Row className="upload-row">
            <div className="dropZoneContent">
              <img className="dropzoneContentIcon" src={DropIcon} alt="DropIcon" />
              <p className="dropZoneContentText">
                {" "}
                Click to select single or multiple files
              </p>
            </div>
            <input
              id="uploadedReport"
              className="upload-input"
              type="file"
              name="myFile"
              onChange={(event) => this.handleUploadPdf(event)}
              multiple
            />
          </Row>
          <div className="uploadTextWarning">
            {" "}
            Only .pdf files are supported
          </div>
        </div>
      </div>
    );
  }
}

export default SendReportsUpload;
